import { http } from 'services';

export function getFoodPrintLabel(type, id, query, cbSuccess, cbError) {
  http.request(
    'get',
    `${type}/${id}/food-label`,
    query,
    null,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
    null,
    'blob'
  );
}



// WEBPACK FOOTER //
// ./src/api/api-stuff-to-eat/api-stuff-to-eat-labels.js